import { ConditionalWrapper } from '@/components/atoms';

export const AdsBanner = ({ image, url, className }) => {
  return (
    <div className={className}>
      <ConditionalWrapper
        condition={!!url}
        wrapper={(children) => (
          <a href={url} target="_blank" rel="noreferrer">
            {children}
          </a>
        )}
      >
        <img className="w-full" src={image} alt="" />
      </ConditionalWrapper>
    </div>
  );
};
